var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"fade"}},[(_vm.viewIsScrolledDown)?_c('div',[_c('button',{staticClass:"button",on:{"click":_vm.click}},[_c('i',{staticClass:"fa fa-arrow-up"})])]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }